var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechBubble47(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7641 6.01064C7.78478 5.67888 8.87747 5.5 10 5.5C15.0523 5.5 19.5 9.1237 19.5 14C19.5 14.7892 19.3835 15.5456 19.1668 16.2591C19.8506 16.5407 20.6981 16.7855 21.7652 16.996C21.9857 17.0395 22.092 16.7174 21.9001 16.5956C20.697 15.832 20.0014 15.0746 19.6839 13.926C21.1157 12.6612 22 10.9209 22 9C22 5.13401 18.4183 2 14 2C10.8039 2 8.04556 3.63996 6.7641 6.01064Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14C18 17.866 14.4183 21 10 21C8.73297 21 7.53474 20.7423 6.47004 20.2835C5.64512 21.0079 4.38652 21.5715 2.23478 21.996C2.01433 22.0395 1.90799 21.7174 2.09988 21.5956C3.30299 20.832 3.99864 20.0746 4.31612 18.926C2.8843 17.6612 2 15.9209 2 14C2 10.134 5.58172 7 10 7C14.4183 7 18 10.134 18 14ZM7.5 14C7.5 13.4477 7.05228 13 6.5 13C5.94772 13 5.5 13.4477 5.5 14C5.5 14.5523 5.94772 15 6.5 15C7.05228 15 7.5 14.5523 7.5 14ZM11 14C11 13.4477 10.5523 13 10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15C10.5523 15 11 14.5523 11 14ZM13.5 15C14.0523 15 14.5 14.5523 14.5 14C14.5 13.4477 14.0523 13 13.5 13C12.9477 13 12.5 13.4477 12.5 14C12.5 14.5523 12.9477 15 13.5 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble47);
export default __webpack_public_path__ + "static/media/speech-bubble-47.8c23756ed18fe37ada1e3547b6ae2336.svg";
export { ForwardRef as ReactComponent };